import { runTransaction, getFirestore } from 'firebase/firestore'
import companyCardService from '../../services/companyCardService'
import companyService from '../../services/companyService'

class SwitchCompanyCardForm {
  onSubmit = async ({
    companyCardId,
    companyId,
  }: {
    companyCardId: string
    companyId: string
  }): Promise<void> => {
    await runTransaction(getFirestore(), async transaction => {
      const [companyCard, company] = await Promise.all([
        companyCardService
          .fetchCompanyCard({
            companyId,
            companyCardId,
            transaction,
          })
          .catch((error: Error) => {
            if (error.message === "CompanyCard doesn't exist") {
              return
            }
            throw error
          }),
        companyService.fetchCompany({ companyId, transaction }),
      ])
      if (!companyCard) {
        throw new Error('Something went wrong. The card you provided doesnt exist.')
      }
      const now = new Date()
      const companyCardExpired =
        companyCard.expiryYear < now.getFullYear() ||
        (companyCard.expiryYear === now.getFullYear() &&
          companyCard.expiryMonth < now.getMonth() + 1)
      if (companyCardExpired) {
        throw new Error('Something went wrong. The card you provided is expired.')
      }
      if (company.stripePaymentMethodId === companyId) {
        throw new Error('Something went wrong. This is already the default payment method.')
      }
      companyService.updateStripePaymentMethod({
        companyId,
        stripePaymentMethodId: companyCardId,
        transactionOrBatch: transaction,
      })
    })
  }
}

export default new SwitchCompanyCardForm()
